import { useParams } from 'react-router';
import { assertIsDefined } from '~/types/assert-type';

export function useRequiredParam(paramName: string): string {
  const params = useParams();
  const result = params[paramName];
  assertIsDefined(result);
  return result;
}
